import React, { useState } from "react";
import './Login.css'
import {signInWithPopup, GoogleAuthProvider} from 'firebase/auth';
import { authetication } from "./firebase-config";
import {useNavigate} from 'react-router-dom';
import Cookies from 'universal-cookie';


function Login(){
    const navigate = useNavigate()
    const [user, setUser] = useState("")
    const cookies = new Cookies();
    // const signIn = useSignIn();
    const signUpWithGoogle = () => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(authetication, provider)
        .then((result) =>{
            console.log(result)
            if(result.user){
                setUser(result.user.displayName)
                cookies.set('USER', result.user.displayName, { path: '/' });
                navigate('/home')}
            else{
                navigate('/')
                cookies.set('USER', '', { path: '/' });
            }
            // signIn({
            //     username:result.user.displayName
            // })
        })
        .catch((err)=>{
            console.log(err.message)
            setUser("")
        })

    }
    return(
        <header className="login"
        style={{
            backgroundSize: "cover",
            backgroundImage: `url("https://149695847.v2.pressablecdn.com/wp-content/uploads/2019/05/apps.55787.9007199266246365.687a10a8-4c4a-4a47-8ec5-a95f70d8852d.jpg")`,
            backgroundPosition: "center center"
        }}
        >
            <div className="login_contents">
                <h1 className="login_title">Hi.{user}</h1>
                <div className="login_buttons">
                    <button className="login_button" onClick={signUpWithGoogle}>Login With Google</button>
                </div>
            </div>
            <div className="login--fadeBottom"></div>
        </header>
    )
};

export default Login;